module.exports = __webpack_public_path__ + "img/stock2.5d482fe4.png";